import { createAction, createReducer } from "redux-act";
import { Feature } from "@evergis/sgis";

import { reducerRegistry } from "../reducerRegistry";

import {
  GeometrySelectionToolTypes,
  GeometrySelectionTypes,
} from "../../modules/Map/components/GeometrySelectionTools/types";

const reducerName = "geometrySelection";

export type SelectionHistoryFeature = Feature & { _rings?: number[][][]; _position?: number[] };

export enum CalculatedFeatureTypes {
  Walking = "walking",
  Car = "car",
}

export interface SelectionHistory {
  features: Array<SelectionHistoryFeature[]>;
  step: number;
}

export interface GeometrySelectionSettings {
  bufferRadius?: string;
  bufferMultiplier?: string;
  bufferInclude?: boolean;
  selectOutside?: boolean;
  routeType?: CalculatedFeatureTypes;
}

export interface GeometrySelectionState {
  active?: boolean;
  loading?: boolean;
  type?: GeometrySelectionTypes;
  currentTool?: GeometrySelectionToolTypes;
  history?: SelectionHistory;
  editHistory?: SelectionHistory;
  isBuffer?: boolean;
  settings?: GeometrySelectionSettings;
}

const initialState: GeometrySelectionState = {
  active: true,
  loading: false,
  type: GeometrySelectionTypes.Point,
  currentTool: GeometrySelectionToolTypes.Replace,
  history: {
    features: [],
    step: -1,
  },
  editHistory: {
    features: [],
    step: -1,
  },
  settings: {
    bufferRadius: "",
    bufferMultiplier: "1",
    bufferInclude: true,
    selectOutside: false,
    routeType: CalculatedFeatureTypes.Walking,
  },
};

export const reducer = createReducer({}, initialState);

export const setGeometrySelection = createAction<GeometrySelectionState>("geometry-selection/set-geometry-selection");

export const clearGeometrySelectionHistory = createAction("geometry-selection/clear-geometry-selection-history");

export const resetGeometrySelection = createAction("geometry-selection/reset-geometry-selection");

reducer.on(setGeometrySelection, (state, payload) => ({
  ...state,
  ...payload,
}));

reducer.on(clearGeometrySelectionHistory, state => ({
  ...state,
  currentTool: GeometrySelectionToolTypes.Replace,
  history: {
    features: [],
    step: -1,
  },
}));

reducer.on(resetGeometrySelection, () => initialState);

reducerRegistry.register(reducerName, reducer);
